import { authFetch } from "./authProvider";

export const fetchOrganizations = async (userData) => {
  const url = "organisation-service/v2/organizations";

  return await authFetch("get", url, {})
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      console.log(error);
      return {};
    });
};
